import React, { useEffect } from "react";
import { Table, Space, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useTechnicianModel } from "../technicianModel";
import { ITechnicianDetail } from "../technicianType";
import { tableSize } from "@/utils/constants";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, onDisabled,
        loadData, setSelectedRowKeys,
    } = useTechnicianModel();
    const columns: ColumnsType<ITechnicianDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (text, record, index) => `${index + 1}`
        }, {
            title: '姓名',
            dataIndex: 'name',
            width: 140,
        }, {
            title: '手机',
            dataIndex: 'phone',
            width: 150,
        }, {
            title: '职位',
            dataIndex: 'title',
            width: 140,
        }, {
            title: '分配点数',
            dataIndex: 'assignPoints',
            width: 140,
        }, {
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 150,
            dataIndex: 'createTime',
        }, {
            title: '操作',
            dataIndex: 'enable',
            width: 140,
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            ),

        }
    ];
    useEffect(() => {
        loadData()
    }, []);

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id as string}
            size={tableSize}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: ITechnicianDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 340px)" }}

        />
    )
}
